<template>
    <v-container>
        <v-row>
            <!-- Page Header -->
            <v-col
                class="col col-md-12"
                style="padding: 12px 0px;"
            >
                <v-toolbar flat>
                    <div class="d-flex justify-space-between align-center">
                        <v-btn
                            icon
                            class="btn-back"
                            @click="backMapLayers()"
                        >
                            <v-icon class="material-icons-outlined">
                                chevron_left
                            </v-icon>
                        </v-btn>
                        <v-toolbar-title
                            class="pl-3"
                        >
                            <span class="title">
                                Draw Shapes
                            </span>
                        </v-toolbar-title>
                    </div>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-divider class="my-3" />
        <v-card flat>
            <v-card-text class="border border-4 mb-2">
                <v-container>
                    <!-- <v-row class="my-6 title">
                        Map Layer Information
                    </v-row> -->
                    <v-row class="subtitle">
                        <v-col class="col-12 col-md-6">
                            <v-row>
                                {{ mapLayer.name }}
                            </v-row>
                            <v-row>
                                {{ mapLayer.description }}
                            </v-row>
                            <v-row class="mb-1">
                                Layer Color:
                                <v-icon :color="getColor(mapLayer.style)">
                                    mdi-circle
                                </v-icon>
                            </v-row>
                        </v-col>
                        <v-col class="col-12 col-md-6">
                            <v-row>
                                <v-row
                                    dense
                                >
                                    <v-col class="col-12 col-md-3">
                                        <v-select
                                            v-model="state"
                                            :items="states"
                                            item-text="state"
                                            item-value="state"
                                            label="State"
                                            hide-details="true"
                                            outlined
                                            dense
                                            :disabled="isDisabled"
                                            @change="updateState"
                                        />
                                    </v-col>
                                    <v-col class="col-12 col-md-9">
                                        <v-select
                                            v-model="county"
                                            :items="counties"
                                            item-text="displayText"
                                            item-value="name"
                                            label="County"
                                            hide-details="true"
                                            outlined
                                            dense
                                            @change="updateCounty"
                                        />
                                    </v-col>
                                </v-row>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col
                            v-if="showGeometryTypes"
                            class="col-12 col-md-6"
                        >
                            <v-select
                                v-model="drawtype"
                                :items="drawTypes"
                                item-text="displayText"
                                item-value="value"
                                label="Geometry type"
                                hide-details="true"
                                outlined
                                dense
                                @change="updateDrawType"
                            />
                        </v-col>
                        <v-col
                            v-if="showGeometryTypes"
                            class="col-12 col-md-6"
                        >
                            <v-select
                                v-model="drawbuffer"
                                :items="bufferValues"
                                item-text="displayText"
                                item-value="value"
                                label="Buffer"
                                hide-details="true"
                                outlined
                                dense
                                @change="updateBuffer"
                            />
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col>
                            <div
                                id="map"
                                ref="map-root"
                                style="height: 75vh; border: 1px solid #ccc; background: white;"
                                :style="{'height': this.$vuetify.breakpoint.xs ? '65vh' : '75vh'}"
                                class="mb-2"
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-spacer />
                    <div class="d-flex mt-2">
                        <v-btn
                            depressed
                            color="primary"
                            @click.once="saveShapes()"
                        >
                            Save
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card-text>
        </v-card>
        <v-dialog
            v-model="loading"
            persistent

            width="100px"
        >
            <v-progress-circular
                indeterminate
                color="primary"
                :size="60"
                :width="4"
            />
        </v-dialog>
        <v-dialog
            v-model="error"
            persistent
            width="300px"
        >
            <v-card>
                <v-card-title>
                    Error
                </v-card-title>
                <v-card-text>
                    {{ errorMessage }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="primary"
                        text
                        @click="error = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import webtmsBackend from '../../../services/webtmsBackend';
// import CenterResponseVue from '../../Queues/CenterResponse/CenterResponse.vue';
import { guidEqual } from '@/utils/guid.js';

import {Style, Stroke, Fill, Text} from 'ol/style';

import 'ol/ol.css';
import {Map, View, Overlay, Feature, PluggableMap} from 'ol' ;
import * as coordinate from 'ol/coordinate';
import * as control from 'ol/control';
import * as events from 'ol/events';
import * as extent from 'ol/extent';
import * as format from 'ol/format';
import * as geom from 'ol/geom';
import * as interaction from 'ol/interaction';
import * as layer from 'ol/layer';
import * as proj from 'ol/proj';
import * as render from 'ol/render';
import * as reproj from 'ol/reproj';
import * as source from 'ol/source';
import * as sphere from 'ol/sphere';
import * as style from 'ol/style';
import * as tilegrid from 'ol/tilegrid';
import * as webgl from 'ol/webgl';
import * as turf from '@turf/turf';

import '@/components/Map/QMOL.css';
import Compass from '@/assets/compass-rose.png';
import Logo from '@/components/Map/QMOL_Logo.png';
import QMOL_Data from '@/components/Map/QMOL_Data.js';
import {quickMap} from '@/components/Map/QMOL.js';

export default {
    name: 'DrawMapLayer',
    data() {
        return {
            error: false,
            errorMessage: '',
            layerId: null,
            loading: false,
            mapLayer:{
                data:[],
                info:[],
                layer_id: '',
                name:'',
                description:'',
                style:{
                    color:'',
                    show:false
                }
            },
            state : '',
            county : null,
            showMap: false,
            featureCollection: {},
            image: {},

            zoomtofeatures: false,
            zoomtost:{},
            zoomtostcounty:{},
            mapview: {},
            layerFeatures: [],
            baseLayer: [],
            drawtype: 'Polygon',  // default draw type
            drawbuffer: 0,      // default draw buffer
            drawTypes: [
                {
                    value: 'Point',
                    displayText: 'Point'
                },
                {
                    value: 'LineString',
                    displayText: 'Line'
                },
                {
                    value: 'Polygon',
                    displayText: 'Polygon'
                },
            ],
            bufferValues: [
                {
                    value: 0,
                    displayText: 'No buffer',
                },
                {
                    value: 50,
                    displayText: '50 ft',
                },
                {
                    value: 100,
                    displayText: '100 ft'
                },
                {
                    value: 150,
                    displayText: '150 ft'
                },
                {
                    value: 200,
                    displayText: '200 ft'
                },
                {
                    value: 500,
                    displayText: '500 ft'
                },
                {
                    value: 750,
                    displayText: '750 ft'
                },
                {
                    value: 1000,
                    displayText: '1,000 ft'
                },
                {
                    value: 1250,
                    displayText: '1,250 ft'
                },
                {
                    value: 1500,
                    displayText: '1,500 ft'
                },
                {
                    value: 1750,
                    displayText: '1,750 ft'
                },
                {
                    value: 2000,
                    displayText: '2,000 ft'
                },
                {
                    value: 2500,
                    displayText: '2,500 ft'
                }
            ],
            showGeometryTypes: true,
            layerData:{
                data:[],
                info:{}
            },
        };
    },
    computed: {
        isDisabled() {
            return this.states.length === 1;
        },
        states() {
            let data = this.$store.getters.counties;
            // Find all unique states
            let states = [...new Set(data.map(item => item[2]))];
            return states;
        },
        counties() {
            let data = this.$store.getters.counties;
            let counties = [];
            // counties.push({state:'', fips:'', name: '*', displayText:'Show ALL'});
            data.forEach(county => {
                let name = county[3];
                let fips = county[1];
                let state = county[2];

                if (counties.indexOf(name) === -1) {
                    if(state === this.state) {
                        counties.push({state:state, fips:fips, name:name, displayText:fips +' - '+ name + ' County, '+ state });
                    }
                }
            });
            return counties;
        },
    },
    created() {
        //
    },
    async mounted() {
        setTimeout(() => {
            this.qm = new quickMap(
                {
                    ol: {View,Map,Overlay,Feature,PluggableMap,control,coordinate,events,extent,format,geom,interaction,layer,proj,render,reproj,source,sphere,style,tilegrid,webgl},
                    turf: turf,
                    target: 'map',
                    compass: Compass,
                    logo: Logo,
                    extraData: QMOL_Data.QMOL_Data,
                }
            );

            this.qm.showBullseye=false;
            this.qm.showIdentify=false;
            this.qm.showWeather=false;4;
            this.qm.showClear=false;

            document.addEventListener('qmolDraw', (e)=> {
                this.addFeature(e);
            });

            document.addEventListener('qmolModify', (e)=> {
                this.modifyFeature(e);
            });

            document.addEventListener('qmolDelete', (e)=> {
                this.removeFeature(e);
            });
        }, 0);

        //
        if(this.$route.params.id){
            this.layerId = this.$route.params.id;
            this.$store.commit('SET_LAYER_ID', this.layerId);
        }
        this.companyLayers = this.$store.getters.companyLayers;
        this.getLayerInfo();

        // If only one state we need to set the state
        let data = this.$store.getters.counties;
        let states = [...new Set(data.map(item => item[2]))];
        if (states.length === 1) {
            this.updateState(states[0]);
        }
    },
    methods: {
        async updateState(state) {
            this.state = state;
            setTimeout(async () => {
                this.qm.zoomToState(this.state);
                await this.getLayerData();
                this.loadFeatures();
            }, 0);
        },
        updateCounty() {
            this.qm.zoomToCounty(this.state,this.county);
        },
        updateDrawType(type) {
            this.qm.setDrawType = type;
            this.drawtype = type;
            this.setDefaultBufferForType();
        },
        updateBuffer(buffer) {
            this.drawbuffer = buffer;
            this.qm.drawBuffer=buffer;
            this.setDefaultBufferForBuffer();
        },
        setDefaultBufferForType(){
            let bufferToUse=this.drawbuffer;

            if (this.drawbuffer === 0 && this.drawtype !== 'Polygon'){
                bufferToUse = this.bufferValues[3].value;
            } else if (this.drawbuffer !== 0 && this.drawtype === 'Polygon'){
                bufferToUse = this.bufferValues[0].value;
            }

            if (bufferToUse !== this.drawbuffer){
                setTimeout(() => {
                    this.drawbuffer = bufferToUse;
                    this.qm.drawBuffer=this.drawbuffer;
                }, 0);
            }
        },
        setDefaultBufferForBuffer(){
            let bufferToUse=this.drawbuffer;

            if (this.drawbuffer === 0 && this.drawtype !== 'Polygon'){
                bufferToUse = this.bufferValues[3].value;
            }

            if (bufferToUse !== this.drawbuffer){
                setTimeout(() => {
                    this.drawbuffer = bufferToUse;
                    this.qm.drawBuffer=this.drawbuffer;
                }, 0);
            }
        },
        getDefaultCountyName() {
            let defaultCountyName = null;
            for(let i = 0; i < this.counties.length; i++) {
                if(this.counties[i].state === this.state) {
                    defaultCountyName = this.counties[i].name;
                    break;
                }
            }
            return defaultCountyName;
        },
        backMapLayers() {
            this.$router.push({ path: '/settings/map-layers' });
        },
        async getLayerInfo() {
            if(!this.layerId) {
                this.layerId = this.$store.getters.layerId;
            }
            this.mapLayer = this.$store.getters.companyLayers.find(layer => guidEqual(layer.layer_id, this.layerId));
        },
        async getLayerData() {
            // clear layer features, and if none checked or too far out then leave
            this.layerFeatures = [];
            let currentLayer = {
                data: [],
                info:{
                    layers: [],
                    map:{}
                },
            };

            currentLayer.info.layers.push(this.mapLayer.layer_id);
            // Show the loading spinner
            this.loading = true;
            // get layer data from backend via store action
            let response = await webtmsBackend.getLayerData(
                currentLayer.info.layers,
                this.qm.getMapExtentObj(),
            );
            // Hide the loading spinner
            this.loading = false;
            this.layerData.data= response.data;
            this.layerData.info= response.info;
            // add layer features to map
            for (var i = 0; i < response.info.layers.length; i++) {
                // handle response.info
                // get layer name and style
                const layer_id = this.mapLayer.layer_id;
                // set defaults
                let name = '';
                let show = true;
                let color = '';
                let fips = '';
                // get data from companyLayers for building feature
                for (const companyLayer of this.companyLayers){
                    name = companyLayer.name;
                    let style= companyLayer.style;
                    if (!style.color) style = JSON.parse(companyLayer.style);
                    if (guidEqual(companyLayer.layer_id, layer_id)){
                        show = style.show;
                        color = style.color;
                        break;
                    }
                }
                const strokeColor = this.hexToRGBA(color,1);
                const fillColor = this.hexToRGBA(color,0.2);
                this.qm.editColor=this.hexToRgb(color);

                // get shape data a layer features
                for (const shape_data of response.data[i]){
                    this.layerFeatures.push({
                        type: 'Feature',
                        properties: {
                            layer_id: layer_id,
                            rowid:shape_data[0],
                            name: name,
                            fips: fips,
                            show: show,
                            style: function(zoom){
                                return zoom<0?undefined:new Style({
                                    text:new Text({text:zoom<14?'':name,font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:-15}),
                                    stroke:new Stroke({color:strokeColor,width:2}),
                                    fill:new Fill({color:fillColor}),
                                });
                            },
                        },
                        geometry: {
                            type: 'Polygon',
                            coordinates: JSON.parse(`[[[${shape_data[1].replace(/,-/g,'],[-')}]]]`)
                        }
                    });
                }
            }
        },
        loadFeatures(){
            // setup for features
            this.featureCollection = {
                type: 'FeatureCollection',
                features: [],
            };
            // add layer features
            if(this.layerFeatures.length > 0){
                for (const feature of this.layerFeatures) {
                    this.featureCollection.features.push(feature);
                }
            }
            // send it all off to the map containter
            this.qm.addToEdit(this.featureCollection);
            this.qm.zoomToEdit();
        },
        hexToRGBA (hex, alpha) {
            if (hex.length>7) {hex=hex.substring(0,7);}
            return `${hex}${Math.floor(alpha * 255).toString(16).padStart(2, 0)}`;
        },
        hexToRgb(hex) {
            if (hex.length>7) {hex=hex.substring(0,7);}
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? [
                parseInt(result[1], 16),
                parseInt(result[2], 16),
                parseInt(result[3], 16)
            ] : [0,0,0];
        },
        getColor(style) {
            let s = style;
            if(typeof style === 'string') {
                s = JSON.parse(style);
            }
            if(s.color) {
                return s.color;
            } else {
                return '#808080';
            }
        },
        async saveShapes(){
            let responseErrors = [];
            for (const feature of this.featureCollection.features) {
                if (feature.geometry.type === 'Polygon' && feature.properties.modified ){
                    let shapes = [];
                    // Fields passed to backend ['layer_id', 'rowid', 'fips', 'name', 'shapestring'];
                    let layer = {};
                    // layer_id
                    layer.layer_id = feature.properties.layer_id;
                    // rowid
                    layer.rowid = feature.properties.rowid ? feature.properties.rowid : undefined;
                    // fips
                    layer.fips = feature.properties.fips;
                    // Add Shapes
                    shapes.push(feature.geometry.coordinates[0]);
                    layer.name = this.mapLayer.name;
                    layer.shapestring = shapes.join(',');
                    layer.operation =  feature.properties.rowid ? feature.properties.operation : 'insert';
                    let response = await  webtmsBackend.saveMapLayerFeatures(layer);
                    if(response.err){
                        responseErrors.push(response.err);
                    }
                }
            }
            if(responseErrors.length === 0){
                this.$store.dispatch('getCompanyLayers');
                this.$router.push({ path: '/settings/map-layers' });
                this.$store.dispatch('setSnackbar', {
                    text: 'Map layer updated successfully!',
                    color: 'success'
                });
            }else{
                this.$store.dispatch('setSnackbar', {
                    text: responseErrors.join(','),
                    color: 'error'
                });
            }
        },
        addFeature(event){
            const feature = event.detail.features.features[0];
            if (feature.properties.kinks || feature.properties.rings>1) return;
            let name = '';
            let color = '';
            let show = true;
            for (const companyLayer of this.companyLayers){
                let style= companyLayer.style;
                if (!style.color) style = JSON.parse(companyLayer.style);
                if (guidEqual(companyLayer.layer_id, this.mapLayer.layer_id)){
                    name = companyLayer.name;
                    show = style.show;
                    color = style.color;
                    break;
                }
            }
            const strokeColor = this.hexToRGBA(color,1);
            const fillColor = this.hexToRGBA(color,0.2);
            this.featureCollection.features.push({
                type: 'Feature',
                properties:{
                    fid: feature.properties.fid,
                    layer_id: this.mapLayer.layer_id,
                    show: show,
                    modified: true,
                    operation: 'insert',
                    fips: feature.properties.fips[0],
                    style: function(zoom){
                        return zoom<0?undefined:new Style({
                            text:new Text({text:zoom<14?'':name,font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:-15}),
                            stroke:new Stroke({color:strokeColor,width:2}),
                            fill:new Fill({color:fillColor}),
                        });
                    }
                },
                geometry: feature.geometry
            });
        },
        modifyFeature(event){
            const features=event.detail.features.features;
            for (const feature of features){
                if (feature.properties.kinks || feature.properties.rings>1) return;
            }
            for(let i=0;i<features.length; i++) {
                for(let j=0;j<this.featureCollection.features.length; j++) {
                    if(
                        (!features[i].properties.rowid && features[i].properties.fid && features[i].properties.fid === this.featureCollection.features[j].properties.fid)  ||
                    (features[i].properties.rowid && features[i].properties.rowid === this.featureCollection.features[j].properties.rowid)
                    ){
                    // Add modified property
                        this.featureCollection.features[j].properties.modified=true,
                        this.featureCollection.features[j].properties.operation = 'update',
                        this.featureCollection.features[j].properties.fips = features[i].properties.fips[0],
                        // Clear coordinates
                        this.featureCollection.features[j].geometry.coordinates = [];
                        // Add coordinates from feature
                        for(let k=0; k<features[i].geometry.coordinates.length; k++ ) {
                            this.featureCollection.features[j].geometry.coordinates.push(features[i].geometry.coordinates[k]);
                        }
                        break;
                    }
                }
            }
        },
        removeFeature(event){
            const features=event.detail.features.features;
            for(let i=0;i<features.length; i++) {
                for(let j=0;j<this.featureCollection.features.length; j++) {
                    if(!features[i].properties.rowid && features[i].properties.fid && features[i].properties.fid === this.featureCollection.features[j].properties.fid ){
                        this.featureCollection.features.splice(j,1);
                        break;
                    } else if(features[i].properties.rowid && features[i].properties.rowid === this.featureCollection.features[j].properties.rowid){
                    // Add modified property
                        this.featureCollection.features[j].properties.modified=true,
                        this.featureCollection.features[j].properties.fips = '00000';
                        this.featureCollection.features[j].properties.operation = 'delete';
                        break;
                    }
                }
            }
        },
        showgeometrytypes(){
            this.showGeometryTypes = true;
        },
    }
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>